module.exports = __webpack_public_path__ + "static/media/menu18.213c92ab.jpg";